const global = window

inputs.alias.flexGrid = 'group'
inputs.alias.subForm = 'group'
inputs.alias.html = 'group'

inputs.types.group = function (data, name, niceName, type, input, parent, inputWindow) {
    data.ajaxType = 'html'

    let inputResult = input.next();

    if (inputResult.length) inputs.fn.paramedit.applyJson(inputResult, input);
    setTimeout(function() {
        input.find('input, textarea, select').change(function() {
            inputs.fn.paramedit.generateJson(inputResult, input, this, []);
        });
    }, 100)
    data.update = function (inputData, response) {
        if (input.attr('data-id')) {
            inputs.contextual = getFormData(input, true)
            let newHtml = $(response)
                .find('[data-id="' + input.attr('data-id') + '"]')
                .html()
            if (!newHtml) newHtml = response;
            const newScripts = $(response).filter('script').html()
            BEHAV.apply(input, 'unload');
            input.html(newHtml)
            eval(newScripts)
            BEHAV.apply(input);
            BEHAV.apply(input, inputWindow.data('behavkey'));
            inputs.contextual = {}
        }

        let inputResult = input.next();

        if (inputResult.length) {
            inputs.fn.paramedit.applyJson(inputResult, input);
            input.find('input, textarea, select').change(function() {
                input.removeData('lock-pe');
                inputs.fn.paramedit.generateJson(inputResult, input, this, []);
            });
        }
    }
    return data
}
